import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
/**
 * 设置sessionStorage
 * @param {string} key
 * @param {any} value
 */
export function setCache(key, value) {
  console.log('setCache - 设置缓存:', key, value);
  if (value == undefined || value == null) {
    window.sessionStorage.setItem(key, value);
  } else {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }
}

/**
 * 获取sessionStorage
 * @param {string} key
 * @returns {any}
 */
export function getCache(key) {
  const value = window.sessionStorage.getItem(key);
  console.log('getCache - 获取缓存:', key, value);
  if (value == 'undefined' || value == null) {
    return undefined;
  }
  return JSON.parse(value);
}

/**
 * 清除指定sessionStorage
 * @param {string} key
 */
export function removeCache(key) {
  return window.sessionStorage.removeItem(key);
}

/**
 * 清除所有sessionStorage
 */
export function removeAll(key) {
  return window.sessionStorage.clear();
}